import * as React from "react";

import { useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import { Modal } from "../../components/modal/Modal";
import { getCities, deleteCity } from "../../redux/actions/cityActions";
import { useAppDispatch } from "../../redux/hooks";
import { CityResponse } from "../../api/generated/index";
import { SUCCESS_DELETE } from "../../constants/messageConstants";
import { handleToast } from "../../utils/helpers";

interface CityTableProps {
  cities: CityResponse[];
}

export const CityTable: React.FC<CityTableProps> = ({ cities }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const currentItem = React.useRef<CityResponse | null>(null);
  const [showDeletePopup, setShowDeletePopup] = React.useState<boolean>(false);

  const handleOpen = (item: CityResponse) => {
    setShowDeletePopup(true);
    currentItem.current = item;
  };
  const handleClose = () => {
    setShowDeletePopup(false);
  };

  const onDelete = (id: number) => {
    dispatch(deleteCity(id))
      .unwrap()
      .then(() => {
        dispatch(getCities());
        handleToast(SUCCESS_DELETE);
      });
    handleClose();
  };

  const onCancel = () => {
    handleClose();
  };

  const onAdd = (id: number) => {
    navigate(`new/${id}`);
  };

  return (
    <>
      <Toaster position="top-center" reverseOrder={true} />
      <h2 className="manager__title">List of added cities</h2>
      <div className="manager__content">
        <table className="table">
          <thead>
            <tr className="table__row">
              <th className="table__head">City name</th>
              <th className="table__head">Country name</th>
              <th className="table__head table__head--action">Edit</th>
              <th className="table__head table__head--action">Delete</th>
            </tr>
          </thead>
          <tbody>
            {cities.map((item) => {
              return (
                <tr className="table__row" key={item.id}>
                  <td className="table__cell">{item.name}</td>
                  <td className="table__cell">{item.country?.name}</td>
                  <td className="table__cell">
                    <button
                      onClick={() => onAdd(item.id!)}
                      className="link link--icon link--edit"
                    >
                      Edit
                    </button>
                  </td>
                  <td className="table__cell">
                    <button
                      onClick={() => handleOpen(item)}
                      className="link link--icon link--delete"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Modal show={showDeletePopup} handleClose={onCancel}>
        <h2 className="popup__heading-plain">
          Are you sure you want to delete this city?
        </h2>
        <div className="popup__actions">
          <button
            onClick={onCancel}
            type="button"
            className="btn btn--transparent popup__btn"
          >
            Cancel
          </button>
          <button
            onClick={() => onDelete(currentItem.current?.id!)}
            type="button"
            className="btn popup__btn"
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};
